'use client';

import { usePathname } from 'next/navigation';
import { resolveAppArea } from '@/contexts/app/area';
import { getAppPolicy, type AppPolicy } from '@/contexts/app/policy';

/**
 * 当前路由所在区域的策略，与首帧脚本、middleware 共用同一张前缀表。
 * 纯派生，没有副作用；同一区域返回同一个静态对象，引用稳定。
 */
export function useAppPolicy(): AppPolicy {
    return getAppPolicy(resolveAppArea(usePathname() ?? '/'));
}
